export default "__VITE_ASSET__CEP$Zth___"